exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/index.js??postcss!../common.css"), "");

// module
exports.push([module.id, "ngui-map {\r\n    width: 100%; \r\n    min-width: 840px;\r\n    height: 500px;\r\n    box-shadow: 3px 3px 2px rgb(182, 182, 182);\r\n} ", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/map/map.component.css
// module id = ../../../../../src/app/map/map.component.css
// module chunks = main